// extracted by mini-css-extract-plugin
export default {"textareaWrapper":"Textarea_textareaWrapper__9hgla","textarea":"Textarea_textarea__bcVwk","error":"Textarea_error__rDdX3","errorLabel":"Textarea_errorLabel__LfXi9"};